(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("q"), require("jquery"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["q", "jquery", "axios"], factory);
	else if(typeof exports === 'object')
		exports["PayseraRecaptchaModal"] = factory(require("q"), require("jquery"), require("axios"));
	else
		root["PayseraRecaptchaModal"] = factory(root["Q"], root["jQuery"], root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    modalSelector: '#recaptch-modal',
    contentSelector: '#recaptch-modal .content',
    loaderSelector: '#recaptch-modal .loader'
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modalEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_paysera_event_emitter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_paysera_event_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_paysera_event_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_modal__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_modal_html__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_modal_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__template_modal_html__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var modalEvents = {
    afterOpened: 'after-opened',
    afterClosed: 'after-closed'
};

var Modal = function () {
    function Modal() {
        var modalSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var modalContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Modal);

        this.modalSelector = modalSelector === null ? __WEBPACK_IMPORTED_MODULE_2__config_modal__["a" /* default */].modalSelector : modalSelector;
        this.modalContent = modalContent === null ? __WEBPACK_IMPORTED_MODULE_3__template_modal_html___default.a : modalContent;

        this.eventEmitter = new __WEBPACK_IMPORTED_MODULE_1_paysera_event_emitter__["EventEmitter"]();

        this.modal = this.initModal();

        this.initEvents();
    }

    _createClass(Modal, [{
        key: 'initModal',
        value: function initModal() {
            if (this.getModal().length === 0) {
                var modalElement = window.document.createElement('div');
                modalElement.innerHTML = this.modalContent;

                window.document.body.appendChild(modalElement);
            }

            return this.getModal();
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            var _this = this;

            this.modal.on('shown.bs.modal', function () {
                _this.eventEmitter.emit(modalEvents.afterOpened);
            });

            this.modal.on('hidden.bs.modal', function () {
                _this.eventEmitter.emit(modalEvents.afterClosed);
            });
        }
    }, {
        key: 'on',
        value: function on(event, callback) {
            this.eventEmitter.on(event, function () {
                callback();
            });
        }
    }, {
        key: 'open',
        value: function open() {
            this.modal.modal('show');
        }
    }, {
        key: 'close',
        value: function close() {
            this.modal.modal('hide');
        }
    }, {
        key: 'getModal',
        value: function getModal() {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.modalSelector);
        }
    }]);

    return Modal;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (Modal);




/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_modal__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var Recaptcha = function () {
    function Recaptcha(recaptchaProvider, unlockResolver) {
        var modalSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var loaderSelector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var modalTemplate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var unlockUrl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

        _classCallCheck(this, Recaptcha);

        this.recaptchaProvider = recaptchaProvider;
        this.unlockResolver = unlockResolver;
        this.modal = new __WEBPACK_IMPORTED_MODULE_3__modal__["b" /* Modal */](modalSelector, modalTemplate);
        this.loaderSelector = loaderSelector === null ? __WEBPACK_IMPORTED_MODULE_2__config_modal__["a" /* default */].loaderSelector : loaderSelector;
        this.unlockUrl = typeof unlockUrl === 'string' ? unlockUrl : null;

        this.opened = false;

        this.openDeferred = null;
        this.closeDeferred = null;
        this.recaptchaDeferred = null;

        this.initDeferreds();
        this.initEvents();
    }

    _createClass(Recaptcha, [{
        key: 'initEvents',
        value: function initEvents() {
            var _this = this;

            this.modal.on(__WEBPACK_IMPORTED_MODULE_3__modal__["a" /* modalEvents */].afterOpened, function () {
                return _this.afterOpenedModal();
            });
            this.modal.on(__WEBPACK_IMPORTED_MODULE_3__modal__["a" /* modalEvents */].afterClosed, function () {
                return _this.afterClosedModal();
            });
        }
    }, {
        key: 'initDeferreds',
        value: function initDeferreds() {
            this.initOpenDeferred();
            this.initCloseDeferred();
            this.initRecaptchaDeferred();

            this.openDeferred.resolve();
            this.closeDeferred.resolve();
            this.recaptchaProvider.init();
        }
    }, {
        key: 'open',
        value: function open() {
            var recaptchaProviderConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.openResolver(recaptchaProviderConfig);

            return this.recaptchaDeferred.promise;
        }
    }, {
        key: 'openResolver',
        value: function openResolver() {
            var _this2 = this;

            var recaptchaProviderConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.opened === false) {
                this.opened = true;

                this.initOpenDeferred();
                this.initRecaptchaDeferred();

                this.closeDeferred.promise.finally(function () {
                    _this2.modal.open();
                });

                this.openDeferred.promise.then(function () {
                    _this2.recaptchaProvider.show(recaptchaProviderConfig).then(function (response) {
                        _this2.showLoader();

                        _this2.recaptchaDeferred.resolve(response);
                    }).catch(function (response) {
                        _this2.recaptchaDeferred.reject(response);
                    });
                });
            }

            return this.openDeferred.promise;
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            if (this.opened === true) {
                this.opened = false;

                this.initCloseDeferred();

                this.openDeferred.promise.finally(function () {
                    _this3.modal.close();
                });

                this.closeDeferred.promise.then(function () {
                    _this3.recaptchaProvider.destroy();
                    _this3.recaptchaDeferred.reject();
                });
            }
        }
    }, {
        key: 'afterOpenedModal',
        value: function afterOpenedModal() {
            this.openDeferred.resolve();
        }
    }, {
        key: 'afterClosedModal',
        value: function afterClosedModal() {
            this.closeDeferred.resolve();
        }
    }, {
        key: 'initRecaptchaDeferred',
        value: function initRecaptchaDeferred() {
            var _this4 = this;

            this.recaptchaDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();

            this.recaptchaDeferred.promise = this.recaptchaDeferred.promise.then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_1_q___default.a.when(_this4.unlockResolver(response, _this4.unlockUrl)).then(function () {
                    return response;
                });
            }).then(function (response) {
                _this4.close();

                return response;
            }).catch(function (response) {
                _this4.close();

                return __WEBPACK_IMPORTED_MODULE_1_q___default.a.reject(response);
            }).finally(function () {
                _this4.hideLoader();
            });
        }
    }, {
        key: 'initOpenDeferred',
        value: function initOpenDeferred() {
            this.openDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
        }
    }, {
        key: 'initCloseDeferred',
        value: function initCloseDeferred() {
            this.closeDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
        }
    }, {
        key: 'showLoader',
        value: function showLoader() {
            var element = this.getLoaderElement();

            if (element !== null) {
                element.classList.remove('hidden');
            }
        }
    }, {
        key: 'hideLoader',
        value: function hideLoader() {
            var element = this.getLoaderElement();

            if (element !== null) {
                element.classList.add('hidden');
            }
        }
    }, {
        key: 'getLoaderElement',
        value: function getLoaderElement() {
            var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.loaderSelector);

            return element.length > 0 ? element[0] : null;
        }
    }]);

    return Recaptcha;
}();

/* harmony default export */ __webpack_exports__["a"] = (Recaptcha);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interceptor_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_recaptcha__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recaptcha_google__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axios__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createAxiosResponseInterceptor", function() { return __WEBPACK_IMPORTED_MODULE_0__interceptor_axios__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResponseErrorInterceptor", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_axios__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "modalEvents", function() { return __WEBPACK_IMPORTED_MODULE_1__modal_modal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_1__modal_modal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RecaptchaModal", function() { return __WEBPACK_IMPORTED_MODULE_2__modal_recaptcha__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GoogleRecaptcha", function() { return __WEBPACK_IMPORTED_MODULE_3__recaptcha_google__["a"]; });








/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_q__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_recaptcha__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = (function (recaptchaProvider, recaptchaConfig, needsRecaptcha, unlockResolver) {
    var modalSelector = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var loaderSelector = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var modalContent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    var interceptorModal = null;

    return function (error) {
        if (needsRecaptcha(error) !== true) {
            return __WEBPACK_IMPORTED_MODULE_0_q___default.a.reject(error);
        }

        var configProvider = recaptchaConfig;
        if (typeof recaptchaConfig === 'function') {
            configProvider = recaptchaConfig(error);
        }

        return __WEBPACK_IMPORTED_MODULE_0_q___default.a.when(configProvider).then(function (config) {

            if (interceptorModal === null) {
                interceptorModal = new __WEBPACK_IMPORTED_MODULE_1__modal_recaptcha__["a" /* default */](recaptchaProvider, unlockResolver, modalSelector, loaderSelector, modalContent, config.unlockUrl);
            }

            return interceptorModal.open(config).then(function () {
                return error.config.instance.request(error.config);
            }, function () {
                return __WEBPACK_IMPORTED_MODULE_0_q___default.a.reject(error);
            });
        });
    };
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_modal__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Google = function () {
    function Google(language) {
        var siteKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var elementSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 15000;
        var cspNonce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        _classCallCheck(this, Google);

        this.language = language;
        this.siteKey = siteKey;
        this.elementSelector = elementSelector === null ? __WEBPACK_IMPORTED_MODULE_2__config_modal__["a" /* default */].contentSelector : elementSelector;
        this.timeout = timeout;
        this.cspNonce = cspNonce;

        this.gRecaptcha = null;
        this.loader = null;

        this.widgetId = null;
        this.rendered = false;

        this.submitDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
    }

    _createClass(Google, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.loader = this.load().then(function (gRecaptcha) {
                return _this.gRecaptcha = gRecaptcha;
            });
        }
    }, {
        key: 'load',
        value: function load() {
            if (typeof window.grecaptcha === 'undefined') {
                var googleRecaptchDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
                var callbackMethodName = 'onGoogleRecaptchaLoadCallback_' + new Date().getTime();

                var timeoutId = setTimeout(function () {
                    if (typeof window.grecaptcha === 'undefined') {
                        googleRecaptchDeferred.reject();
                        window[callbackMethodName] = function () {};
                    }
                }, this.timeout);

                window[callbackMethodName] = function () {
                    clearTimeout(timeoutId);
                    googleRecaptchDeferred.resolve(window.grecaptcha);
                };

                var url = 'https://www.google.com/recaptcha/api.js' + ('?onload=' + callbackMethodName + '&render=explicit&hl=' + encodeURIComponent(this.language));

                this.loadRecaptcha(url);

                return googleRecaptchDeferred.promise;
            }

            return __WEBPACK_IMPORTED_MODULE_1_q___default.a.when(window.grecaptcha);
        }
    }, {
        key: 'show',
        value: function show(config) {
            var _this2 = this;

            var siteKey = this.siteKey;

            if (config !== null && (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && typeof config.siteKey !== 'undefined') {
                siteKey = config.siteKey;
            }

            if (this.loader === null) {
                this.init();
            }

            return this.loader.then(function () {
                if (_this2.rendered === false) {
                    _this2.render(siteKey);
                } else {
                    _this2.reset();
                }

                _this2.getElement().classList.remove('hidden');

                return _this2.submitDeferred.promise;
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.getElement().classList.add('hidden');

            this.submitDeferred.reject();
            this.initSubmitDeferred();
        }
    }, {
        key: 'submitCallback',
        value: function submitCallback(gRecaptchaResponse) {
            this.submitDeferred.resolve({ response: gRecaptchaResponse });
        }
    }, {
        key: 'expiredCallback',
        value: function expiredCallback() {
            this.reset();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.gRecaptcha.reset(this.widgetId);
        }
    }, {
        key: 'render',
        value: function render(siteKey) {
            var _this3 = this;

            if (this.rendered === true) {
                return;
            }

            this.rendered = true;

            var element = this.getElement();

            this.widgetId = this.gRecaptcha.render(element, {
                sitekey: siteKey,
                callback: function callback(response) {
                    return _this3.submitCallback(response);
                },
                expired: function expired() {
                    return _this3.expiredCallback();
                }
            });
        }
    }, {
        key: 'initSubmitDeferred',
        value: function initSubmitDeferred() {
            this.submitDeferred = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
        }
    }, {
        key: 'getElement',
        value: function getElement() {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.elementSelector)[0];
        }
    }, {
        key: 'loadRecaptcha',
        value: function loadRecaptcha(source) {
            var element = window.document.createElement('script');
            element.type = 'text/javascript';
            element.src = source;

            if (this.cspNonce !== null) {
                element.setAttribute('nonce', this.cspNonce);
            }

            window.document.getElementsByTagName('head')[0].appendChild(element);
        }
    }]);

    return Google;
}();

/* harmony default export */ __webpack_exports__["a"] = (Google);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultResponseErrorInterceptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function defaultResponseErrorInterceptor(responseErrorInterceptor) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
        return response;
    }, responseErrorInterceptor);
}



/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\"\n     role=\"dialog\"\n     id=\"recaptch-modal\"\n     data-backdrop=\"static\"\n>\n    <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">Recaptcha</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <div class=\"loader hidden\">loading...</div>\n                        <div class=\"content\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PayseraEventEmitter"] = factory();
	else
		root["PayseraEventEmitter"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
    function EventEmitter() {
        _classCallCheck(this, EventEmitter);

        this.listeners = {};
    }

    _createClass(EventEmitter, [{
        key: "on",
        value: function on(name, callback) {
            if (!Array.isArray(this.listeners[name])) {
                this.listeners[name] = [];
            }

            this.listeners[name].push(callback);

            return this;
        }
    }, {
        key: "off",
        value: function off(name, callback) {
            if (Array.isArray(this.listeners[name])) {
                for (var index = 0; index < this.listeners[name].length; index++) {
                    var listener = this.listeners[name][index];
                    if (listener === callback) {
                        this.listeners[name].splice(index, 1);

                        break;
                    }
                }
            }

            return this;
        }
    }, {
        key: "emit",
        value: function emit(name, parameters) {
            if (!Array.isArray(this.listeners[name])) {
                return;
            }

            this.listeners[name].forEach(function (callback) {
                return callback(parameters);
            });
        }
    }], [{
        key: "forwardMessage",
        value: function forwardMessage(observable, name) {
            return function (message) {
                observable.emit(name, message);
            };
        }
    }]);

    return EventEmitter;
}();

exports.default = EventEmitter;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventEmitter = __webpack_require__(0);

Object.defineProperty(exports, 'EventEmitter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_eventEmitter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);
});
//# sourceMappingURL=app.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ]);
});